<template>
  <div class="context">
    <div class="context__wrapper">
      <div class="context__choices-wrapper">
        <button
          v-for="(context, i) in contexts"
          :key="`search-context-${i}`"
          :class="
            currentContext === context
              ? 'context__choice context__chosen'
              : 'context__choice'
          "
          :style="hasResults(context) ? '' : 'display: none;'"
          @click="updateContext(context)"
        >
          {{ context }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Context',
  props: {
    viewStyle: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      currentContext: 'search/searchContext',
      contexts: 'search/contexts',
      coursesResultCount: 'search/coursesResultCount',
      playlistsResultCount: 'search/playlistsResultCount',
      videosResultCount: 'search/videosResultCount',
      isFiltersCollapsed: 'search/isFiltersCollapsed',
    }),
  },
  methods: {
    updateContext(context) {
      this.$store.dispatch('search/setSearchContext', context)
    },
    hasResults(context) {
      switch (context) {
        case 'Courses':
          return this.coursesResultCount > 0
        case 'Learning Paths':
          return this.playlistsResultCount > 0
        case 'Videos':
          return this.videosResultCount > 0
        default:
          return true
      }
    },
    toggleFilters() {
      this.$store.dispatch('search/setIsFiltersCollapsed', true)
    },
  },
  created() {
    if (window.innerWidth < 768) {
      this.toggleFilters()
    }
  },
}
</script>

<style lang="scss" scoped>
.context {
  margin: 0 0 20px 0;
  width: 100%;
  &__wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__choices-wrapper {
    display: flex;
    width: 100%;
  }
  &__choice {
    white-space: nowrap;
    background: transparent;
    color: var(--white);
    margin: 0 5px 0 0;
    transition: 0.5s all ease;
    border: none;
    padding: 0 0 10px 0;
    font-size: 1rem;
    margin: 0 15px;
    text-transform: uppercase;
    &:hover {
      cursor: pointer;
    }
  }
  &__chosen {
    font-weight: 700;
    border-bottom: 1px solid var(--orange);
  }
  &__toggle-filters-btn {
    width: 25%;
    display: block;
    background: transparent;
    border: none;
    color: var(--white);
    text-align: end;
    @include tablet {
      display: none;
    }
    &:hover {
      cursor: pointer;
    }
  }
  &__toggle-filters-btn-icon {
    font-size: 3rem;
    transition: 0.5s all ease;
  }
}
</style>
